import { filTableExtended_ADR } from './fil-table.component';

customElements.define('fil-table-adr', filTableExtended_ADR);
